import { Button, Icon, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const EditButton = ({ className = '', noLabel = true, fullWidth = false, onClick }) => {
  const { t } = useTranslation()
  const label = t(`services::accesses.list.extra_actions.edit`)

  const button = (
    <Button
      variant={'ghost'}
      grey
      link={!noLabel}
      startIcon={<Icon name={'pen'} />}
      noLabel={noLabel}
      fullWidth={fullWidth}
      align={noLabel ? undefined : 'left'}
      size={'s'}
      className={className}
      onClick={onClick}
    >
      {!noLabel && label}
    </Button>
  )

  return noLabel ? <Tooltip title={label}>{button}</Tooltip> : button
}

EditButton.propTypes = {
  action: PropTypes.string,
  login: PropTypes.string,
  icon: PropTypes.string,
  processing: PropTypes.bool,
  className: PropTypes.string,
  toggleTo: PropTypes.oneOf(['activate', 'archive']),
  checkboxHandleChange: PropTypes.func,
  onClick: PropTypes.func,
  noLabel: PropTypes.bool,
  fullWidth: PropTypes.bool,
}
